import styled from 'styled-components'
import { Breakpoints, Colors, Spacing } from '@doordash/design-language'

export const ImageContainer = styled.div`
  svg {
    width: 100%;
  }
`

interface BulletListProps {
  mb?: keyof typeof Spacing
}

type BulletListItemProps = BulletListProps

type SectionImageHeaderProps = {
  imageUrl: string
}

export const SectionImageHeader = styled.div`
  background-image: url(${(props: SectionImageHeaderProps) => props.imageUrl});
  width: 100%;
  min-height: 222px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const BulletList = styled.ul`
  color: ${Colors.SystemGrey80};
  padding-left: 16px;
  ${(props: BulletListProps) =>
    props.mb && `margin-bottom: ${Spacing[props.mb]}px`}
`

export const NumericList = styled.ul`
  list-style-type: decimal;
  color: ${Colors.SystemGrey80};
  padding-left: 16px;
  ${(props: BulletListProps) =>
    props.mb && `margin-bottom: ${Spacing[props.mb]}px`}
`

export const BulletListItem = styled.li`
  ${(props: BulletListItemProps) =>
    props.mb && `margin-bottom: ${Spacing[props.mb]}px`}
`

export const SlideButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ProgressContainer = styled.div`
  margin: auto ${Spacing.XxLarge}px;

  @media (min-width: ${Breakpoints.Mobile}px) {
    margin: auto ${Spacing.XxxLarge}px;
  }
`

export const ModalContentPadding = styled.div`
  padding: 16px;
`

export const Box = styled.div`
  ${(props: React.CSSProperties) =>
    props.marginLeft && `margin-left: ${props.marginLeft}px;`}
  ${(props: React.CSSProperties) =>
    props.display && `display: ${props.display};`}
  ${(props: React.CSSProperties) =>
    props.alignItems && `align-items: ${props.alignItems};`}
`
